import type { IDirectConversationEntity, IWorkspaceConversationEntity } from "./conversation.model";
import { DIRECT_CONVERSATION_PREFIX, WORKSPACE_CONVERSATION_PREFIX } from "./conversation.model";

export function isWorkspaceConversation(conversation?: {
	workspaceId?: string;
}): conversation is IWorkspaceConversationEntity {
	return Boolean(conversation?.workspaceId);
}

export function isDirectMessageConversation(conversation?: {
	conversationId?: string;
}): conversation is IDirectConversationEntity {
	return Boolean(conversation?.conversationId);
}

export function getConversationKey(entity: {
	workspaceId?: string;
	participantId?: string;
}): string {
	return isWorkspaceConversation(entity)
		? WORKSPACE_CONVERSATION_PREFIX + entity.workspaceId
		: DIRECT_CONVERSATION_PREFIX + entity.participantId;
}
